import _ from 'lodash';
import Vue from 'vue';
import { IOrder, OrderDetails, IOrderProductsMap } from '@/service/types';
import { 
  IOrderState,
  IParamUpdateQuantity,
  IQueueElement,
  IParamUpdateValidationProduct
} from '@/store/types';

export default {
  UPDATE_ORDERS(state: IOrderState, payload: Array<IOrder>) {
    state.orders = payload;
  },
  UPDATE_SEARCH_QUERY(state: any, payload: string) {
    state.searchQuery = payload;
  },
  UPDATE_DETAILED(state: IOrderState, payload: OrderDetails) {
    Vue.set(state.ordersDetailed, payload.id, payload);
  },
  UPDATE_MAP(state: IOrderState, payload: IOrderProductsMap) {
    state.orderProductsMap = payload;
  },
  UPDATE_VALIDATION(state: IOrderState, payload: IParamUpdateQuantity) {
    if (!_.has(state.ordersValidationContext, payload.orderId)) {
      Vue.set(
        state.ordersValidationContext, 
        payload.orderId, 
        {
          productValidation: {}
        }
      );
    }
    if (!_.has(
      state.ordersValidationContext[payload.orderId].productValidation, 
      payload.productIndex
    )) {
      let item: any = {
        quantity: payload.quantity
      };
      if (payload.product) {
        item.product = payload.product;
      }
      Vue.set(
        state.ordersValidationContext[payload.orderId].productValidation,
        payload.productIndex, 
        item
      );
    } else {
      state
        .ordersValidationContext
        [payload.orderId]
        .productValidation 
        [payload.productIndex]
        .quantity = payload.quantity;
      if (payload.product) {
        Vue.set(
          state.ordersValidationContext[payload.orderId].productValidation[payload.productIndex], 
          'product',
          _.cloneDeep(payload.product)
        );
      }
    }
  },
  UPDATE_VALIDATION_PRODUCT(state: IOrderState, payload: IParamUpdateValidationProduct) {
    if (_.has(
      state.ordersValidationContext,
      `${payload.orderId}.productValidation.${payload.productEan}.product`
    )) {
      Vue.set(
        state.ordersValidationContext[payload.orderId].productValidation[payload.productEan], 
        'product',
        _.cloneDeep(payload.product)
      );
    }
  },
  SUBSTRACT_FROM_COLLECTION(state: IOrderState, idOrder: number) {
    if (_.has(state.ordersDetailed, idOrder)) {
      let clone = _.cloneDeep(state.ordersDetailed);
      _.unset(clone, idOrder);
      Vue.set(state, 'ordersDetailed', clone);
    }
    if (_.has(state.orderProductsMap, idOrder)) {
      let clone = _.cloneDeep(state.orderProductsMap);
      _.unset(clone, idOrder);
      Vue.set(state, 'orderProductsMap', clone);
    }
    Vue.set(state, 'orders', _.filter(state.orders, (item) => {
      return item.id !== idOrder;
    }));
  },
  REMOVE_VALIDATION_CONTEXT(state: IOrderState, idOrder: number) {
    if (_.has(state.ordersValidationContext, idOrder)) {
      let clone = _.cloneDeep(state.ordersValidationContext);
      _.unset(clone, idOrder);
      Vue.set(state, 'ordersValidationContext', clone);
    }
  },
  ENQUEUE_REQUEST(state: IOrderState, payload: IQueueElement) {
    state.queue.push(payload);
  },
  FULFILL_ENQUEUED_REQUESTS(state: IOrderState, payload: Array<number>) {
    Vue.set(state, 'queue', _.filter(state.queue, (item) => {
      return _.indexOf(payload, item.idOrder) === -1;
    }));
  },
  UPDATE_NEXT_POSSIBLE_UPDATE_TIME(state: IOrderState, payload: number) {
    state.nextPossibleUpdateTime = payload;
  },
};
